import cookie from 'cookie-utils-js';
import { mapGetters } from 'vuex';
import { getBoostCards } from '@/api/credits';
import { mixins } from '@/mixins';
import NoMoreData from '@/components/NoMoreData/NoMoreData.vue';
import AreaLoading from '@/components/AreaLoading/AreaLoading.vue';
import DataPlaceHolder from '@/components/DataPlaceHolder/DataPlaceHolder.vue';

export default {
  components: {
    NoMoreData,
    AreaLoading,
    DataPlaceHolder
  },
  
  name: 'BoostCards',

  mixins: [mixins],

  data() {
    return {
      firstLoading: false,
      dataList: [
        {
          img: '',
          name: 'name',
          used: false,
          expire_time: '2025-07-03 14:22'
        }
      ],
      nomoreData: false,
      listLoading: false,
      page: 1,
    }
  },

  computed: {
    ...mapGetters([
      'pageBackgroundColor',
      'cardBackgroundColor',
      'hignlightBorderColor',
      'cardBtnBackgroundColor',
      'primaryBtnBackgroundColor',
      'virtualCurrencyUnit'
    ]),
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.firstLoading = true;
      this.dataList = [];
      this.nomoreData = false;
      this.listLoading = false;
      this.page = 1;
      await this.getBoostCards({
        page: this.page,
      });
      this.firstLoading = false;
    },

    async getBoostCards(opts) {
      const appid = cookie.get('App-Id') || this.debugAppId;
      const token = cookie.get('token') || this.debugToken;
      const res = await getBoostCards({
        token,
        appid,
        page: opts.page
      });
      const currentList = this.makeRenderList(res.data.list);

      if (currentList.length < 10) {
        this.nomoreData = true;
      }

      this.dataList = this.dataList.concat(currentList);
    },

    async onScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      
      if (this.listLoading || this.nomoreData || this.firstLoading) {
        return;
      }

      if(scrollTop + clientHeight >= scrollHeight - 200) {
        this.page++;
        this.listLoading = true;
        await this.getBoostCards({
          page: this.page,
        });
        this.listLoading = false;
      }
    },

    getStatusName(item) {
      if (item.expired) {
        return 'Expired';
      }

      if (item.status === 0) {
        return 'Unused';
      }

      if (item.status === 1) {
        return 'Used';
      }
    },

    makeRenderList(dataList) {
      return dataList.map((item) => {
        return {
          user_sku_id: item.user_sku_id,
          status: item.status,
          name: item.name,
          img_url: item.img_url,
          expire_time: this.toLocalTime(item.expire_time),
          expired: item.expired,
          use_base_price: item.use_base_price
        };
      });
    },
  }
}



